import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { SpecraHeading } from '../ensigns/typography';
/** Section header used between dashboard blocks, or a ruled group label within one. */ export const SpecraSectionHeader = /*#__PURE__*/ React.forwardRef(({ action, className, headingAs, headingId, title, variant = 'section', ...props }, ref)=>{
    if (variant === 'group') {
        const Heading = headingAs ?? 'h3';
        return /*#__PURE__*/ _jsxs("div", {
            className: cn('flex items-center gap-[var(--space-3)] border-b border-border pb-[var(--space-1-5)]', className),
            "data-variant": "group",
            ref: ref,
            ...props,
            children: [
                /*#__PURE__*/ _jsx(Heading, {
                    className: "min-w-0 font-sans text-[length:var(--fs-ui-eyebrow)] font-medium uppercase leading-[var(--lh-tight)] tracking-[var(--ls-ui-group)] text-muted-foreground",
                    id: headingId,
                    children: title
                }),
                action ? /*#__PURE__*/ _jsx("div", {
                    className: "ml-auto flex shrink-0 items-center gap-[var(--space-2)]",
                    children: action
                }) : null
            ]
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('mb-3.5 flex items-baseline justify-between gap-3', className),
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ _jsx(SpecraHeading, {
                as: headingAs ?? 'h2',
                id: headingId,
                size: "sm",
                children: title
            }),
            action
        ]
    });
});
SpecraSectionHeader.displayName = 'SpecraSectionHeader';
/** @deprecated Use SpecraSectionHeader. */ export const SectionHeader = SpecraSectionHeader;
